export default "__VITE_ASSET__DtN98Bi0__"